(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ae-cart-enhancements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ae-cart-recommendations')) {
    let ranks = {};
    try { ranks = JSON.parse(sessionStorage.getItem('ae-cart-rec-ranks-v2') || '{}'); } catch (_) {}
    customElements.define('ae-cart-recommendations', class extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected) return;
          const rows = Array.from(this.querySelectorAll('ae-cart-recommendation'));
          rows.forEach(row => { const id = row.dataset.productId; if (typeof ranks[id] !== 'number') ranks[id] = Math.random(); });
          rows.sort((a,b) => ranks[a.dataset.productId] - ranks[b.dataset.productId]);
          rows.forEach((row,index) => { row.hidden = index >= 5; row.dataset.aeShow = String(index < 5); row.style.order = index; row.dataset.aeLast = String(index === Math.min(rows.length, 5) - 1); });
          try { sessionStorage.setItem('ae-cart-rec-ranks-v2', JSON.stringify(ranks)); } catch (_) {}
        });
      }
    });
  }

  if (!customElements.get('ae-cart-recommendation')) {
    customElements.define('ae-cart-recommendation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const select = this.querySelector('select[name="id"]');
        const add = this.querySelector('[name="add"]');
        select?.addEventListener('change', () => {
          add.disabled = !select.value;
          const price = select.selectedOptions[0]?.dataset.price;
          if (price) this.querySelector('.ae-rec-price').textContent = price;
          const compare = this.querySelector('.ae-rec-compare');
          compare.textContent = select.selectedOptions[0]?.dataset.compare || '';
          compare.hidden = !compare.textContent;
          const saving = this.querySelector('.ae-rec-saving');
          saving.textContent = select.selectedOptions[0]?.dataset.saving || '';
          saving.hidden = !saving.textContent;
          const option = select.selectedOptions[0];
          const image = this.querySelector('.ae-rec-image img');
          const source = option?.dataset.image;
          if (image && source) {
            if (image.getAttribute('src') !== source) {
              image.removeAttribute('srcset');
              image.src = source;
            }
            image.alt = option.dataset.imageAlt || '';
          }
          if (option?.dataset.url) {
            this.querySelectorAll('.ae-rec-image, .ae-rec-title').forEach(link => { link.href = option.dataset.url; });
          }
          this.querySelector('.ae-rec-error').hidden = true;
        }, {signal});
        this.addEventListener('cart:add:error', e => {
          const error = this.querySelector('.ae-rec-error');
          error.hidden = false;
          if (typeof e.detail?.error === 'string') error.textContent = e.detail.error;
        }, {signal});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  if (!window.aeDrawerEnhancements) {
    window.aeDrawerEnhancements = true;
    let scrollTop = null;
    let busy = false;
    let timer;
    let progressBefore;
    let checkoutBefore;
    const locked = new Map();
    const drawer = () => document.getElementById('CartDrawer');
    const block = e => { e.preventDefault(); e.stopImmediatePropagation(); };
    const lockControls = () => {
      drawer()?.querySelectorAll('hdt-quantity-wrapp button,input[will-change-cart],wrapp-remove-item-oncart,.ae-rec-add,.ae-rec-form select,[data-ay500-remove],[name="checkout"]').forEach(node => {
        if (locked.has(node)) return;
        locked.set(node, {disabled:node.disabled,readOnly:node.readOnly,ariaDisabled:node.getAttribute('aria-disabled')});
        node.setAttribute('aria-disabled','true');
        if (node.matches('hdt-quantity-wrapp button,.ae-rec-form select,[name="checkout"]')) node.disabled = true;
        if (node.matches('input[will-change-cart]')) node.readOnly = true;
      });
    };
    const preview = quantity => {
      const pair = drawer()?.querySelector('.ay500-pair');
      if (!pair) return;
      const wasApplied = pair.classList.contains('ay500-pair--applied');
      const previousCount = Number(pair.querySelector('.ay500-pair-track').getAttribute('aria-valuenow'));
      if (wasApplied && previousCount >= 2 && quantity >= 2) return;
      progressBefore = {node:pair,html:pair.innerHTML,applied:wasApplied};
      pair.classList.remove('ay500-pair--applied');
      pair.setAttribute('aria-busy','true');
      pair.querySelector('.ay500-pair-copy span').textContent = pair.dataset.updating;
      const count = Math.min(Math.max(quantity,0),2);
      const track = pair.querySelector('.ay500-pair-track');
      track.setAttribute('aria-valuenow',String(count));
      track.firstElementChild.style.width = `${count * 50}%`;
      pair.querySelector('.ay500-pair-dot--one').classList.toggle('is-active',count >= 1);
      pair.querySelector('.ay500-pair-dot--two').classList.toggle('is-active',count >= 2);
    };
    const recover = () => {
      if (!busy) return;
      const pair = drawer()?.querySelector('.ay500-pair');
      if (pair) pair.querySelector('.ay500-pair-copy span').textContent = pair.dataset.reloading;
      location.reload();
    };
    const start = (delta = 0) => {
      const d = drawer();
      if (!d || busy) return;
      scrollTop = d.querySelector('[data-hdt-scroll-me]')?.scrollTop ?? 0;
      busy = true;
      clearTimeout(timer);
      const checkout = d.querySelector('[name="checkout"]');
      checkoutBefore = checkout ? {node:checkout,disabled:checkout.disabled,ariaBusy:checkout.getAttribute('aria-busy')} : null;
      if (checkout) { checkout.disabled = true; checkout.setAttribute('aria-busy','true'); }
      document.dispatchEvent(new CustomEvent('ae:cart:update:start'));
      setTimeout(() => {
        if (!busy) return;
        const quantity = Array.from(d.querySelectorAll('input[will-change-cart][name="updates[]"]')).reduce((sum,input) => sum + (Number(input.value) || 0),0);
        preview(quantity + delta);
        lockControls();
      }, 0);
      timer = setTimeout(recover, 15000);
    };
    const finish = (restore = false) => {
      busy = false;
      clearTimeout(timer);
      scrollTop = null;
      if (restore && progressBefore?.node.isConnected) {
        progressBefore.node.innerHTML = progressBefore.html;
        progressBefore.node.classList.toggle('ay500-pair--applied',progressBefore.applied);
        progressBefore.node.removeAttribute('aria-busy');
      }
      progressBefore = null;
      locked.forEach((state,node) => {
        if (!node.isConnected) return;
        if (node.matches('hdt-quantity-wrapp button,.ae-rec-form select')) node.disabled = state.disabled;
        if (node.matches('input[will-change-cart]')) node.readOnly = state.readOnly;
        if (state.ariaDisabled === null) node.removeAttribute('aria-disabled');
        else node.setAttribute('aria-disabled',state.ariaDisabled);
      });
      locked.clear();
      const checkout = drawer()?.querySelector('[name="checkout"]');
      if (checkout === checkoutBefore?.node) {
        checkout.disabled = checkoutBefore.disabled;
        if (checkoutBefore.ariaBusy === null) checkout.removeAttribute('aria-busy');
        else checkout.setAttribute('aria-busy',checkoutBefore.ariaBusy);
      }
      checkoutBefore = null;
    };
    document.addEventListener('click', e => {
      const control = e.target.closest?.('#CartDrawer hdt-quantity-wrapp button,#CartDrawer wrapp-remove-item-oncart,#CartDrawer .ae-rec-add,#CartDrawer [data-ay500-remove],#CartDrawer [name="checkout"]');
      if (!control) return;
      if (busy) { block(e); return; }
      if (control.matches('hdt-quantity-wrapp button')) {
        const input = control.closest('hdt-quantity-wrapp').querySelector('input');
        const previous = input.value;
        start();
        setTimeout(() => { if (busy && input.value === previous) finish(true); }, 0);
      } else if (control.matches('wrapp-remove-item-oncart')) {
        const input = control.closest('hdt-line-item').querySelector('input[will-change-cart]');
        start(-(Number(input?.value) || 0));
      }
    }, true);
    document.addEventListener('submit', e => {
      const d = e.target.closest?.('#CartDrawer');
      if (!d) return;
      if (busy) { block(e); return; }
      if (e.target.matches('.ae-rec-form') && e.target.checkValidity()) start(Number(new FormData(e.target).get('quantity')) || 1);
    }, true);
    document.addEventListener('change', e => {
      const target = e.detail?.target || e.target;
      if (target?.closest?.('#CartDrawer') && (target.hasAttribute('will-change-cart') || target.matches('wrapp-remove-item-oncart'))) start();
    }, true);
    document.addEventListener('cart:drawer:render', () => {
      if (scrollTop !== null) {
        const scroller = drawer()?.querySelector('[data-hdt-scroll-me]');
        if (scroller) scroller.scrollTop = scrollTop;
      }
      finish();
    });
    document.addEventListener('cart:change', e => {
      if (busy && !Number.isFinite(e.detail?.cart?.item_count)) recover();
    });
    document.addEventListener('cart:add:error', e => {
      if (e.target.closest?.('#CartDrawer')) { finish(true); scrollTop = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aeeyaa-atc-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.documentElement;

  if (root.dataset.aeeyaaAtcMotionInitialized === 'true') {
    return;
  }

  root.dataset.aeeyaaAtcMotionInitialized = 'true';

  const selector = '#MainContent .hdt-main-product-form .hdt-product-form__submit[name="add"]';
  const boundButtons = new WeakSet();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const bindButton = (button) => {
    if (boundButtons.has(button)) {
      return;
    }

    boundButtons.add(button);

    let isVisible = false;
    let readyTimer;

    const playReady = () => {
      window.clearTimeout(readyTimer);

      if (
        reduceMotion.matches ||
        !isVisible ||
        button.disabled ||
        button.getAttribute('aria-busy') === 'true' ||
        button.dataset.aeeyaaAtcAnimated === 'true'
      ) {
        return;
      }

      readyTimer = window.setTimeout(() => {
        if (
          !isVisible ||
          button.disabled ||
          button.getAttribute('aria-busy') === 'true' ||
          button.dataset.aeeyaaAtcAnimated === 'true'
        ) {
          return;
        }

        button.dataset.aeeyaaAtcAnimated = 'true';
        button.classList.add('aeeyaa-atc-ready');
      }, 220);
    };

    button.addEventListener('animationend', (event) => {
      if (event.animationName === 'aeeyaa-atc-ready') {
        button.classList.remove('aeeyaa-atc-ready');
      }

      if (event.animationName === 'aeeyaa-atc-success') {
        button.classList.remove('aeeyaa-atc-success');
      }
    });

    const formWrapper = button.closest('wrapp-hdt-pr-frm');

    formWrapper?.addEventListener('variant:add', () => {
      window.clearTimeout(readyTimer);
      button.dataset.aeeyaaAtcAnimated = 'true';
      button.classList.remove('aeeyaa-atc-ready');
      button.classList.add('aeeyaa-atc-success');

      window.setTimeout(() => {
        button.classList.remove('aeeyaa-atc-success');
      }, 700);
    });

    const buttonStateObserver = new MutationObserver(playReady);
    buttonStateObserver.observe(button, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-busy']
    });

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver((entries) => {
        isVisible = entries[0]?.isIntersecting === true && entries[0].intersectionRatio >= 0.72;

        if (isVisible) {
          playReady();
        } else {
          window.clearTimeout(readyTimer);
        }
      }, {
        threshold: [0.72]
      });

      visibilityObserver.observe(button);
    } else {
      isVisible = true;
      playReady();
    }
  };

  const bindAll = () => {
    document.querySelectorAll(selector).forEach(bindButton);
  };

  bindAll();

  const mainContent = document.getElementById('MainContent');

  if (mainContent) {
    const contentObserver = new MutationObserver(bindAll);
    contentObserver.observe(mainContent, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('shopify:section:load', bindAll);
})();
  } catch(e) { console.error(e); }
})();

})();
